import { render } from "./complianceComponent.vue?vue&type=template&id=4d709ae3&scoped=true&ts=true"
import script from "./complianceComponent.vue?vue&type=script&lang=ts"
export * from "./complianceComponent.vue?vue&type=script&lang=ts"

import "./complianceComponent.vue?vue&type=style&index=0&id=4d709ae3&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d709ae3"]])

export default __exports__